import React, { memo, PropsWithChildren } from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import TableRow from "./TableRow";
import TableColumn from "./TableColumn";
import { nanoid } from "nanoid";

import s from "./Table.less";
import Preloader from "~/components/Preloader";
import { boolean, number, string } from "yup";
import { useUser } from "~/shared/context/UserContext";

interface IProps {
  items;
  errors?;
  options: ({ key: string; handle: () => string } | string)[];
  optionChildren?: string[];
  arrTableRowsPeriod?: string[];
  nameChildren?: string[];
  objectArr?: [];
  subtotals?;
  type: string;
  role?: string;
  control?;
  handleSubmit?;
  setValue?;
  selectParent?;
  onSubmit?;
  onSumbitDublicate?;
  loading?: boolean;
  refetch?;
  btnEdit?: boolean;
  btnView?: boolean;
  btnDel?: boolean;
  btnDownload?: boolean;
  btnCustom?: (props: any) => JSX.Element;
  btnEditStatus?: boolean;
  btnVersion?: boolean;
  btnIndicators?: boolean;
  withChbx?: boolean;
  sortable?: boolean;
  striped?: boolean;
  striped_th?: boolean;

  positionStiki?: boolean;
  styleRow?: boolean;
  collSpanTh?: boolean;
  wrap?: boolean;
  customClassName?: string;
  groupNameSrr?: string;
  customTableHeaderClass?: string;
  reportSelect?: string;
  onSet?: () => void;
  noClick?: boolean;
  localizationName?: string;
  nameColumnChildren?: string[];
  optionsChildren?: string[];
  HeaderComponent?: React.FC<PropsWithChildren<any>>;
  FooterComponent?: React.FC<any>;
  TableBodyComponent?: any;
  customHeader?: any;
  groupSrr?: any;
  headerBorderPerElementsCount?: number | number[];
  rowCanBeClicked?: ((item: any) => boolean) | boolean;
  rowClickHandler?: (item: any) => void;
  searchTextForSelect_ONLY_SRR?: string;
  rowValuesDecorator?: (
    value: any,
    optionName: string,
    dataObject?: any
  ) => any;
  customRowReactKey?: string;
}
export const getKeyFromOptionsTable = (
  optionName: { key: string; handle: () => string } | string
) => (typeof optionName === "string" ? optionName : optionName.key);

const Table: React.FC<IProps> = ({
  items = [],
  options = [],
  errors,
  optionChildren = [],
  arrTableRowsPeriod = [],
  objectArr = [],
  nameChildren = [],
  nameColumnChildren = [],
  optionsChildren = [],
  subtotals = {},
  type,

  control,
  onSubmit,
  onSumbitDublicate,
  selectParent,
  handleSubmit,
  setValue,
  loading = false,
  btnEdit = false,
  btnView = false,
  btnDownload = false,
  btnCustom,
  positionStiki = false,
  btnDel = false,
  btnVersion = false,
  btnEditStatus = false,
  btnIndicators = false,
  withChbx = false,
  sortable = true,
  striped = false,
  striped_th = false,
  styleRow = false,

  wrap = false,
  customClassName = "",
  customTableHeaderClass = "",
  groupNameSrr = "",
  onSet,
  noClick = false,
  localizationName,
  HeaderComponent,
  FooterComponent,
  TableBodyComponent,
  customHeader,
  groupSrr,
  headerBorderPerElementsCount,
  rowClickHandler,
  rowCanBeClicked,
  rowValuesDecorator,
  searchTextForSelect_ONLY_SRR,
  refetch,
  customRowReactKey,
}) => {
  const { t } = useTranslation();
  const { dealerChoice } = useUser();
  const isDealer = dealerChoice === "one";
  // roleCheck === "dealer" || roleCheck === "holding";
  const arrTO = [
    "TO0",
    "TO1",
    "TO2",
    "TO3",
    "TO4",
    "TO5",
    "TO6",
    "TO7",
    "TO8",
    "GO1",
    "GO2",
    "GO3",
    "NoWarranty",
    ...arrTableRowsPeriod,
  ];

  const optionGeneral = optionsChildren.length > 0 ? optionsChildren : options;

  const colSpanSrr = (name) => {
    switch (name) {
      case "cars":
        return 6;
      case "client":
      case "dealer":
        return 3;
      default:
        return nameColumnChildren.length;
    }
  };

  const arrNameConsolidated = ["cars", "client", "dealer"];

  return (
    <>
      <div
        className={clsx({
          [s.s_table]: true,
          [s.t_striped]: striped,
          [s.t_striped_th]: striped_th,

          [s.padding_none]: type === "srr",
          [customClassName]: true,
        })}
      >
        {loading && <Preloader wrap={wrap} />}
        <table>
          {/* Кастомный трехуровневый динамический хедер */}
          {(type === "srr-custom" || type === "srr") && (
            <thead>
              {type === "srr" && (
                <tr
                  key={nanoid()}
                  className={clsx(s.srrColumn, {
                    [s.positionStikiSrr]: positionStiki,
                  })}
                >
                  {options?.map((optionName, id) => {
                    return (
                      !arrTO.includes(getKeyFromOptionsTable(optionName)) && (
                        <th key={id} />
                      )
                    );
                  })}

                  {options?.map((optionName, id) => {
                    return (
                      arrTO.includes(getKeyFromOptionsTable(optionName)) && (
                        <th
                          className={s.arrTO}
                          colSpan={colSpanSrr(optionName)}
                          key={id}
                        >
                          {arrTableRowsPeriod.includes(
                            getKeyFromOptionsTable(optionName)
                          ) &&
                          !arrNameConsolidated.includes(
                            getKeyFromOptionsTable(optionName)
                          )
                            ? optionName
                            : t(`srr.${optionName}`)}
                        </th>
                      )
                    );
                  })}
                </tr>
              )}
              {type === "srr-custom" &&
                (customHeader ? customHeader : []).map((row, index) => (
                  <tr
                    className={clsx(s.srrColumn, {
                      [s.positionStikiSrr1]: positionStiki && index === 0,
                      [s.positionStikiSrr2]: positionStiki && index === 1,
                      [s.positionStikiSrr3]: positionStiki && index === 2,
                    })}
                    style={{
                      top: `${
                        customHeader.length === 2
                          ? index === 0
                            ? "0"
                            : "30px"
                          : index === 0
                          ? "0"
                          : index === 1
                          ? "30px"
                          : "60px"
                      }`,
                    }}
                    key={nanoid()}
                  >
                    {row.map((cell) => (
                      <th
                        className={s.arrTO}
                        key={nanoid()}
                        colSpan={
                          typeof cell !== "string" && cell.colSpan
                            ? cell.colSpan
                            : 1
                        }
                      >
                        {typeof cell !== "string" ? cell.name : cell}
                      </th>
                    ))}
                  </tr>
                ))}
            </thead>
          )}
          {HeaderComponent ? (
            <HeaderComponent>
              <tr>
                {optionGeneral.map((optionTableName, index) => {
                  const showBorder = Array.isArray(headerBorderPerElementsCount)
                    ? headerBorderPerElementsCount.includes(index)
                    : index % headerBorderPerElementsCount === 0;
                  return (
                    <TableColumn
                      localizationName={localizationName}
                      type={type}
                      name={optionTableName}
                      nameChildren={nameChildren}
                      key={
                        type === "srr"
                          ? nanoid()
                          : getKeyFromOptionsTable(optionTableName)
                      }
                      nameColumnChildren={nameColumnChildren}
                      noClick={noClick}
                      sortable={sortable}
                      positionStiki={positionStiki}
                      borderRight={showBorder ? "1px solid black" : ""}
                      // collSpanTh={collSpanTh}
                    />
                  );
                })}
                {(btnEdit ||
                  btnView ||
                  btnDel ||
                  btnVersion ||
                  btnIndicators ||
                  btnDownload ||
                  !!btnCustom ||
                  (onSumbitDublicate && isDealer)) && (
                  <th className={s.with_btns}>
                    <div
                      style={{
                        width:
                          btnEdit && btnView && btnDel
                            ? "180px"
                            : btnEdit &&
                              (btnDel ||
                                btnIndicators ||
                                btnDownload ||
                                !!btnCustom)
                            ? "125px"
                            : "105px",
                      }}
                    />
                  </th>
                )}
              </tr>
            </HeaderComponent>
          ) : (
            <thead className={s.header}>
              <tr
                className={clsx({
                  [s.positionStiki]: positionStiki,
                  [s.positionStikiSrrSecond]: type === "srr",
                })}
              >
                {optionGeneral.map((optionTableName) => (
                  <TableColumn
                    localizationName={localizationName}
                    type={type}
                    name={getKeyFromOptionsTable(optionTableName)}
                    nameChildren={nameChildren}
                    key={
                      type === "srr"
                        ? nanoid()
                        : getKeyFromOptionsTable(optionTableName)
                    }
                    nameColumnChildren={nameColumnChildren}
                    noClick={noClick}
                    sortable={sortable}
                    positionStiki={positionStiki}
                    customTableHeaderClass={customTableHeaderClass}
                    // collSpanTh={collSpanTh}
                  />
                ))}
                {(btnEdit ||
                  btnView ||
                  btnDel ||
                  btnVersion ||
                  btnIndicators ||
                  btnDownload ||
                  !!btnCustom ||
                  (onSumbitDublicate && isDealer)) && (
                  <th className={s.with_btns}>
                    <div
                      style={{
                        width:
                          btnEdit && btnView && btnDel
                            ? "180px"
                            : btnEdit &&
                              (btnDel ||
                                btnIndicators ||
                                btnDownload ||
                                !!btnCustom)
                            ? "125px"
                            : "105px",
                      }}
                    />
                  </th>
                )}
              </tr>
            </thead>
          )}
          <tbody>
            {TableBodyComponent &&
              items.map((item, index) => (
                <TableBodyComponent
                  key={index}
                  type={type}
                  row={item}
                  items={items}
                  customHeader={customHeader}
                  options={options}
                  optionsChildren={optionsChildren}
                  bonus={
                    !!groupSrr && groupSrr["bonus"] ? groupSrr["bonus"] : ""
                  }
                  group={!!groupSrr && groupSrr ? groupSrr : []}
                />
              ))}

            {!TableBodyComponent &&
              items.map((item, index) => {
                let isEdit = item?.status === "Проверен" ? false : btnEdit;
                if (!item.roles) {
                  return (
                    <TableRow
                      type={type}
                      control={control}
                      btnDownload={btnDownload}
                      btnCustom={btnCustom}
                      btnEdit={isEdit}
                      btnEditStatus={btnEditStatus}
                      groupNameSrr={groupNameSrr}
                      btnView={btnView}
                      handleSubmit={handleSubmit}
                      onSubmit={onSubmit}
                      selectParent={selectParent}
                      btnDel={btnDel}
                      loading={loading}
                      btnVersion={btnVersion}
                      arrTableRowsPeriod={arrTableRowsPeriod}
                      btnIndicators={btnIndicators}
                      nameChildren={nameChildren}
                      withChbx={withChbx}
                      options={options.map((el) =>
                        typeof el === "string" ? el : el.key
                      )}
                      refetch={refetch}
                      searchTextForSelect_ONLY_SRR={
                        searchTextForSelect_ONLY_SRR
                      }
                      optionChildren={
                        !!optionChildren.length
                          ? optionChildren
                          : optionsChildren
                      }
                      styleRow={styleRow}
                      onSet={onSet}
                      onSumbitDublicate={onSumbitDublicate}
                      setValue={setValue}
                      item={item}
                      arrObjects={objectArr}
                      errors={errors}
                      key={`${index}${
                        customRowReactKey ? item[customRowReactKey] : item.id
                      }`}
                      rowCanBeClicked={rowCanBeClicked}
                      rowClickHandler={rowClickHandler}
                      rowValuesDecorator={rowValuesDecorator}
                    />
                  );
                }
                return (
                  <TableRow
                    type={type}
                    control={control}
                    btnDownload={btnDownload}
                    btnCustom={btnCustom}
                    btnEdit={isEdit}
                    btnEditStatus={btnEditStatus}
                    groupNameSrr={groupNameSrr}
                    btnView={btnView}
                    handleSubmit={handleSubmit}
                    onSubmit={onSubmit}
                    selectParent={selectParent}
                    btnDel={btnDel}
                    loading={loading}
                    btnVersion={btnVersion}
                    arrTableRowsPeriod={arrTableRowsPeriod}
                    btnIndicators={btnIndicators}
                    nameChildren={nameChildren}
                    withChbx={withChbx}
                    options={options.map((el) =>
                      typeof el === "string" ? el : el.key
                    )}
                    refetch={refetch}
                    searchTextForSelect_ONLY_SRR={searchTextForSelect_ONLY_SRR}
                    optionChildren={
                      !!optionChildren.length ? optionChildren : optionsChildren
                    }
                    styleRow={styleRow}
                    onSet={onSet}
                    onSumbitDublicate={onSumbitDublicate}
                    setValue={setValue}
                    item={item}
                    arrObjects={objectArr}
                    errors={errors}
                    key={`${index}${
                      customRowReactKey ? item[customRowReactKey] : item.id
                    }`}
                    rowCanBeClicked={rowCanBeClicked}
                    rowClickHandler={rowClickHandler}
                    rowValuesDecorator={
                      // (item.roles.includes(role) || role === "admin") &&
                      rowValuesDecorator
                    }
                  />
                );
              })}
          </tbody>
          {/*-------- ОПЦИОНАЛЬНЫЙ ФУТЕР --------*/}
          {FooterComponent && (
            <FooterComponent
              options={options}
              items={items}
              subtotals={subtotals}
            />
          )}
        </table>
      </div>
    </>
  );
};

export default Table;
